<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <h4 class="mat-dialog-title previewHeading" id="modal-basic-title"> {{
            labelConstants.UnfreezeSessionOfInstructor }} </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
    </div>
    <mat-dialog-content class="">
        <form [formGroup]="unfreezeForm" (ngSubmit)="search()">
            <div class="row">
                <div class="col-lg-12 col-12">
                    <div class="mb-3">
                        <mat-label> {{ labelConstants.SelectInstructor }} <span>*</span></mat-label>
                        <mat-form-field class="w-100 select-customer">
                            <mat-select id="style" placeholder="Select Instructor(s)" [(ngModel)]="selectedHostId"
                                formControlName="host" multiple="true" (selectionChange)="onInstructorChange($event)">
                                <mat-select-trigger [title]="selectedInstructorNames">
                                    {{ selectedInstructorNames }}
                                </mat-select-trigger>
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search Instructor(s)"
                                        noEntriesFoundLabel="No such instructor(s) found."
                                        [formControl]="hostCtrl"></ngx-mat-select-search>
                                </mat-option>
                                <!-- Header -->
                                <div class="dropdown-header">
                                    <table class="dropdown-table">
                                        <thead>
                                            <tr>
                                                <th style="width: 5%;"></th>
                                                <th class="hosted-by">Hosted By</th>
                                                <!-- <th class="email">Email Address</th>
                                                <th class="phone">Phone No.</th> -->
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <!-- Options -->
                                <div class="dropdown-body">
                                    <mat-option *ngFor="let customer of filteredhost | async" [value]="customer.userId">
                                        <table class="dropdown-table">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <div
                                                            class="d-flex align-items-md-center align-items-start justify-content-start gap-1 flex-nowrap flex-column flex-md-row  w-100">
                                                            <img [src]="customer.hostImageUrl"
                                                                (error)="customerDropdownImageHandler(customer)"
                                                                class="img-fluid profile-pic-table me-2" width="40px"
                                                                alt="Not found">
                                                            <div class="inner_details">
                                                                <p class="text-left mb-0" title="{{customer.fullName}}">{{customer.fullName}}</p>
                                                                <div class="email-m" title="{{ customer.email }}"><b>Email</b> {{ customer.email }}</div>
                                                                <div class="phone-m" title="{{ customer.mobileNumber }}"><b>Phone</b>{{ customer.mobileNumber }}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <!-- <td class="email" title="{{customer.email}}">{{ customer.email }}</td>
                                                    <td class="phone" title="{{customer.mobileNumber}}">{{ customer.mobileNumber }}</td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </mat-option>
                                </div>
                            </mat-select>
                        </mat-form-field>
                        <mat-error *ngIf="submitted && unfreezeForm.get('host').hasError('required')">
                            Please select instructor(s).
                        </mat-error>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-6 pe-0">
                            <div class="mb-3">
                                <mat-label> {{ labelConstants.StartDate }}<span>*</span> </mat-label>
                                <mat-form-field class="w-100">
                                    <input matInput [matDatepicker]="picker" placeholder="Select Start Date" [min]="minStartDate" (dateChange)="startDateChange()"
                                        formControlName="startDate">
                                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                                <mat-error *ngIf="submitted && unfreezeForm.get('startDate').hasError('required')">
                                    Please select start date.
                                </mat-error>
                            </div>
                        </div>
                        <div class="session_timer col-lg-3 col-6 ps-0">
                            <div class="mb-3">
                                <mat-label> {{ labelConstants.StartTime }}<span>*</span> </mat-label>
                                <div class="input_time">
                                    <input [ngxTimepicker]="picker5" placeholder="Select Start Time" [min]="minStartTime"
                                        formControlName="startTime" (ngModelChange)="onStartTimeChange($event)">
                                    <div class="clock-icon-svg">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M10 6.5C10 5.94772 9.55229 5.5 9 5.5C8.44771 5.5 8 5.94772 8 6.5V11.5C8 12.0523 8.44771 12.5 9 12.5H12C12.5523 12.5 13 12.0523 13 11.5C13 10.9477 12.5523 10.5 12 10.5H10V6.5Z"
                                                fill="#98A2B3" />
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z"
                                                fill="#98A2B3" />
                                        </svg>
                                    </div>
                                    <ngx-material-timepicker #picker5></ngx-material-timepicker>
                                </div>
                                <mat-error *ngIf="submitted && unfreezeForm.get('startTime').hasError('required')">
                                    Please select start time.
                                </mat-error>
                            </div>
                        </div>
                        <div class="col-lg-3 col-6 pe-0">
                            <div class="mb-3">
                                <mat-label> {{ labelConstants.EndDate }}<span>*</span> </mat-label>
                                <mat-form-field class="w-100">
                                    <input matInput [matDatepicker]="picker1" placeholder="Select End Date" [min]="minEndDate" (dateChange)="endDateChange()"
                                        formControlName="endDate">
                                    <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                </mat-form-field>
                                <mat-error *ngIf="submitted && unfreezeForm.get('endDate').hasError('required')">
                                    Please select end date.
                                </mat-error>
                            </div>
                        </div>
                        <div class="session_timer col-lg-3 col-6 ps-0">
                            <div class="mb-3">
                                <mat-label> {{ labelConstants.EndTime }}<span>*</span> </mat-label>
                                <div class="input_time">
                                    <input [ngxTimepicker]="picker6" placeholder="Select End Time" [min]="minEndTime"
                                        formControlName="endTime" (ngModelChange)="onEndTimeChange($event)">
                                    <div class="clock-icon-svg">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M10 6.5C10 5.94772 9.55229 5.5 9 5.5C8.44771 5.5 8 5.94772 8 6.5V11.5C8 12.0523 8.44771 12.5 9 12.5H12C12.5523 12.5 13 12.0523 13 11.5C13 10.9477 12.5523 10.5 12 10.5H10V6.5Z"
                                                fill="#98A2B3" />
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z"
                                                fill="#98A2B3" />
                                        </svg>
                                    </div>
                                    <ngx-material-timepicker #picker6></ngx-material-timepicker>
                                </div>
                                <mat-error *ngIf="submitted && unfreezeForm.get('endTime').hasError('required')">
                                    Please select end time.
                                </mat-error>
                            </div>
                        </div>
                        <div class="col-lg-12 col-12">
                            <div class="float-end mt33">
                                <button type="submit" class="btn btn-primary">
                                    {{ labelConstants.Search }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="row">
            <div class="col-lg-12">
                <div class="mat-custom-table" *ngIf="sessionList.length > 0">
                    <div class="table-responsive " [ngClass]="!showData ? '' : 'no-data-available'">
                        <!-- <table class="w-100 host_table  mt-3" mat-table [dataSource]="dataSource" aria-describedby="">

                            <ng-container matColumnDef="HostedBy">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header="fullName">
                                    {{ labelConstants.HostedBy }} </th>
                                <td mat-cell *matCellDef="let element" [title]="element.fullName">
                                    <b>{{ element.fullName}}</b>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="ClassName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header="className">
                                    {{ labelConstants.ClassName }} </th>
                                <td mat-cell *matCellDef="let element" [title]="element.className">
                                    {{ element.className}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Date">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header="sessionStartDateTime"> {{
                                    labelConstants.Date }} </th>
                                <td mat-cell *matCellDef="let element"
                                    [title]="element.sessionStartDateTime | date: dateFormat.titleFormat"
                                    class="WrapData"
                                    [innerHTML]="element.sessionStartDateTime | ordinalDate : element.sessionStartDateTime">
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Time">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header="sessionStartDateTime"> {{
                                    labelConstants.Time }} </th>
                                <td mat-cell *matCellDef="let element" class="WrapData" [title]="(element.sessionStartDateTime | date : dateFormat.shortTime) + '-' +
                                    (element.sessionEndDateTime | date : dateFormat.shortTime)">
                                    {{ (element.sessionStartDateTime | date : dateFormat.shortTime) + '-' +
                                    (element.sessionEndDateTime | date : dateFormat.shortTime) }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Participants">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header="participantCount">
                                    {{ labelConstants.Participants }} </th>
                                <td mat-cell *matCellDef="let element" [title]="element.participantCount">
                                    {{ element.participantCount}}
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"
                                [ngClass]="{ Inactive: !row.isActive }">
                            </tr>
                        </table> -->
                        <table class="w-100 host_table mt-3 table">
                            <thead class="host-table-head">
                              <tr>
                                <th>{{labelConstants.HostedBy}}</th>
                                <th>{{labelConstants.ClassName}}</th>
                                <th>{{labelConstants.Date}}</th>
                                <th>{{labelConstants.Time}}</th>
                                <th>{{labelConstants.Participants}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let element of dataSource" [ngClass]="{ Inactive: !element.isActive }">
                                <td [title]="element.fullName">{{ element.fullName }}</td>
                                <td [title]="element.className" *ngIf="element.dataFound">{{ element.className }}</td>
                                <td [title]="element.sessionStartDateTime | date: dateFormat.titleFormat" class="WrapData"
                                    [innerHTML]="element.sessionStartDateTime | ordinalDate : element.sessionStartDateTime" *ngIf="element.dataFound">
                                </td>
                                <td class="WrapData" *ngIf="element.dataFound">
                                  {{ (element.sessionStartDateTime | date : dateFormat.shortTime) + '-' +
                                     (element.sessionEndDateTime | date : dateFormat.shortTime) }}
                                </td>
                                <td [title]="element.participantCount" *ngIf="element.dataFound">{{ element.participantCount }}</td>
                                <td colspan="2" *ngIf="!element.dataFound">{{element.sessionStartDateTime | date:dateFormat.dateRangeTime}} To {{element.sessionEndDateTime | date:dateFormat.dateRangeTime}}</td>
                                <td colspan="2" class="text-danger" *ngIf="!element.dataFound">No session record found and user is freezed for this time period.</td>
                              </tr>
                            </tbody>
                          </table>
                    </div>
                </div>
                <ng-container *ngIf="sessionList.length == 0">
                    <div class="text-center host_table mt-3">
                        <img src="../../../assets/img/login-logo.svg" class="pt-5" alt="" srcset="" height="200px"
                            width="200px">
                        <p class="pb-5"> {{ labelConstants.SelectInstructorAbove }} </p>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="float-end mt-2">
            <button type="submit" class="btn btn-primary" (click)="unfreezeSession()"
                [disabled]="sessionList.length <= 0">
                {{ labelConstants.UnfreezeSession }}
            </button>
        </div>
    </mat-dialog-content>
</div>